import HeroSection, { HeroSectionProps } from "@components/E-Book/Herosection";
import NewLayout from "@components/new-ui/Layout";
import Image from "next/image";
import React from "react";

const HeroSectionData: HeroSectionProps = {
    title: "How WhatsApp automation can shape up the future of better healthcare",
    listHeading:
        "Reimagine patient care through conversational messaging on WhatsApp. Discover how WhatsApp automation transforms communication with your patients, creating a seamless digital front door for your practice.",
    listText: [
        { label: "Create meaningful, personal connections throughout the entire patient journey — from booking to follow-up care" },
        { label: "Reduce administrative burden while providing faster, more responsive care your patients will love" },
        { label: "Meet patients where they already are with secure, compliant communication that works across generations" },
    ],

    buttonText: "Download your free Ebook now!",
    mediaUrl: "https://assets.gallabox.com/gb-home/ebook/healthcare.png",
    altMedia: "gallabox-e-book",
    ebookName: "healthcare",
};

const EBookWhyWhatsappForBusiness: React.FC = () => {
    return (
        <NewLayout
            title="WhatsApp API Guide for Managing Healthcare - Download E-book"
            description="Want to take patient care to the next level? Download the ebook to make your hospital or clinic an efficient safe place for patients with WhatsApp automations."
            canonical="https://gallabox.com/resources/whatsapp-for-healthcare-ebook"
            ogAttributes={{ image: "https://assets.gallabox.com/gb-home/ebook/healthcare-og.png" }}
        >
            <HeroSection {...HeroSectionData} />
            <section className="flex flex-col pb-10 pr-12">
                <div className="px-8 max-w-6xl mx-auto client-logos flex flex-col gap-3">
                    <Image width={221} height={56} src="/frame.png" alt={"Frame"} className="flex-shrink" />
                    <div className="lg:flex justify-between items-center">
                        <h3 className="text-2xl lg:text-3xl font-semibold text-gray-900 mb-14">Trusted by over 2,000 companies across 40+ countries</h3>
                        <div className="flex justify-center mb-9">
                            <Image
                                width={730}
                                height={56}
                                src="https://assets.gallabox.com/gb-home/ebook/client-logo.png"
                                alt="client-logo-data"
                                className="flex-shrink lg:block hidden"
                            />
                            <Image
                                width={730}
                                height={56}
                                src="https://assets.gallabox.com/gb-home/ebook/client-logo.png"
                                alt="client-logo-data"
                                className="flex-shrink lg:hidden"
                            />
                        </div>
                    </div>
                </div>
            </section>
        </NewLayout>
    );
};

export default EBookWhyWhatsappForBusiness;
